export const filterRegistry: FilterOption[] = [
    {
        "id": "region", 
        "label": "Region", 
        "api": "/locations", 
        "apiType":"API",
        "type": "location",
        "filterConfig":{
            "filterKey":"region",
            "filterOperator":"EQUAL"
        },
        "multiSelect": false,
        "parent":""
    },
    {
        "id": "regionCode", 
        "label": "Region", 
        "api": "/locations", 
        "apiType":"API",
        "type": "location",
        "filterConfig":{
            "filterKey":"regionCode",
            "filterOperator":"EQUAL"
        },
        "multiSelect": false,
        "parent":""
    },
    {
        "id": "zone", 
        "label": "Zone", 
        "api": "/locations", 
        "apiType":"API",
        "type": "location",
        "filterConfig":{
            "filterKey":"zone",
            "filterOperator":"EQUAL"
        },
        "multiSelect": false,
        "parent":""
    },
    {
        "id": "state", 
        "label": "State", 
        "api": "/locations", 
        "apiType":"API",
        "type": "location",
        "filterConfig":{
            "filterKey":"state",
            "filterOperator":"EQUAl"
        },
        "multiSelect": false,
        "parent":""
    },
    {
        "id": "city", 
        "label": "City", 
        "api": "/locations", 
        "apiType":"API",
        "type": "location",
        "filterConfig":{
            "filterKey":"city",
            "filterOperator":"EQUAl"
        },
        "multiSelect": false,
        "parent":""
    },
    {
        "id": "groupCode", 
        "label": "Group Code", 
        "api": "", 
        "apiType":"",
        "type": "",
        "filterConfig":{
            "filterKey":"",
            "filterOperator":""
        },
        "multiSelect": false,
        "parent":""
    },
    {
        "id": "district", 
        "label": "District", 
        "api": "/locations", 
        "apiType":"API",
        "type": "location",
        "filterConfig":{
            "filterKey":"district",
            "filterOperator":"EQUAL"
        },
        "multiSelect": false,
        "parent":""
    },
    {
        "id": "branch", 
        "label": "Branch", 
        "api": "/locations", 
        "apiType":"API",
        "type": "location", 
        "filterConfig":{
            "filterKey":"locationHierarchy",
            "filterOperator":"REGEX"
        },
        "multiSelect": false,
        "parent":""
    },
    {
        "id": "loginId", 
        "label": "wdDestCode", 
        "api": "/v1/query/branchSpecificSuppliers",
        "apiType":"QUERY",
        "type": "user", 
        "filterConfig":{
            "filterKey":"",
            "filterOperator":""
        },
        "multiSelect": false,
        "parent":""
    },
    {
        "id": "channel", 
        "label": "Channel", 
        "api": "/v1/distinctFieldData/outletDetails/channel",
        "apiType":"API",
        "type": "outlet", 
        "filterConfig":{
            "filterKey":"channel",
            "filterOperator":"EQUALS"
        },
        "multiSelect": false,
        "parent":""
    },
    {
        "id": "outletType", 
        "label": "Outlet Type", 
        "api": "/v1/distinctFieldData/outletDetails/outletType",
        "apiType":"API",
        "type": "outlet", 
        "filterConfig":{
            "filterKey":"outletType",
            "filterOperator":"EQUALS"
        },
        "multiSelect": false,
        "parent":""
    },
    {
        "id": "outletClass", 
        "label": "Loyalty Type", 
        "api": "/v1/distinctFieldData/outletDetails/outletClass",
        "apiType":"API",
        "type": "outlet", 
        "filterConfig":{
            "filterKey":"outletClass",
            "filterOperator":"EQUALS"
        },
        "multiSelect": false,
        "parent":""
    },
    {
        "id": "outletCategory", 
        "label": "Outlet Category", 
        "api": "/v1/distinctFieldData/outletDetails/outletCategory",
        "apiType":"API",
        "type": "outlet", 
        "filterConfig":{
            "filterKey":"outletCategory",
            "filterOperator":"EQUALS"
        },
        "multiSelect": false,
        "parent":""
    }, 
    {
        "id": "subTerritory", 
        "label": "Pricing Attribute",
        "api": "/v1/query/distinctSubterritory",
        "apiType":"API",
        "type": "", 
        "filterConfig":{
            "filterKey":"subTerritory",
            "filterOperator":"EQUALS"
        },
        "multiSelect": true,
        "parent": ""
    },
    {
        "id": "smart_buy", 
        "label": "SBU", 
        "api": "/v1/distinctFieldData/productDetails/smartBuy", 
        "apiType":"API",
        "type": "",
        "filterConfig":{
            "filterKey":"",
            "filterOperator":""
        },
        "multiSelect": false,
        "parent":""
    },
    {
        "id": "category", 
        "label": "Category", 
        "api": "/v1/distinctFieldData/productDetails/category", 
        "apiType":"QUERY",
        "type": "",
        "filterConfig":{
            "filterKey":"",
            "filterOperator":""
        },
        "multiSelect": false,
        "parent":"smart_buy"
    },
    {
        "id": "brand", 
        "label": "Brand", 
        "api": "/products", 
        "apiType":"API",
        "type": "",
        "filterConfig":{
            "filterKey":"",
            "filterOperator":""
        },
        "multiSelect": false,
        "parent":"category"
    },
    {
        "id": "soh", 
        "label": "SOH", 
        "api": "", 
        "apiType":"",
        "type": "",
        "filterConfig":{
            "filterKey":"",
            "filterOperator":""
        },
        "multiSelect": false,
        "parent":""
    },
    {
        "id": "image", 
        "label": "Image", 
        "api": "/v1/query/imagemanagement", 
        "apiType":"API",
        "type": "",
        "filterConfig":{
            "filterKey":"",
            "filterOperator":""
        },
        "multiSelect": false,
        "parent":""
    },
    {
        "id": "marketName", 
        "label": "Trade Name", 
        "api": "/v1/distinctFieldData/OutletDetails/outletAttr1",
        "apiType":"API",
        "type": "", 
        "filterConfig":{
            "filterKey":"",
            "filterOperator":""
        },
        "multiSelect": true,
        "parent":""
    },
    {
        "id": "bannerDesignation", 
        "label": "Designation", 
        "api": "/v1/distinctFieldData/OutletDetails/outletAttr1",
        "apiType":"API",
        "type": "", 
        "filterConfig":{
            "filterKey":"",
            "filterOperator":""
        },
        "multiSelect": true,
        "parent":""
    }
]

export interface FilterOption{
    id: string;
    label: string;
    parent:string;
    apiType:string;
    filterConfig:{
        filterKey:string
        filterOperator:string
    }
    api: string;
    apiWithFilter?:string;
    preSelectedOption?: string;
    type: string;
    inputType?:string;
    multiSelect: boolean;
}